import { AnvilProvider } from '@servicetitan/anvil2';
import { LDServiceProvider } from '@servicetitan/launchdarkly-service';
import { LogService } from '@servicetitan/log-service';
import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { App, AppProvider } from './modules/app';
import './app.css';

export const Root = () => (
    <StrictMode>
        <AppProvider>
            <BrowserRouter basename="/">
                <LogService endpoint="/api/log" storageKey="LogStorage_ISH">
                    <AnvilProvider>
                        <LDServiceProvider>
                            <App />
                        </LDServiceProvider>
                    </AnvilProvider>
                </LogService>
            </BrowserRouter>
        </AppProvider>
    </StrictMode>
);
